import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateFormatter',
    standalone: false
})
export class DateFormatterPipe implements PipeTransform {

  constructor(private datePipe: DatePipe) {}

  transform(value: any, format: string = 'yyyy-MM-dd HH:mm:ss'): string | null {
    if (!value) return null;
    return this.datePipe.transform(value, format);
  }

}
